import React from "react";
// import Work from "./Work";

const CreateCoin = ({ onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="modal-title">Create a New Coin</h2>
        <form className="modal-form">
          <input type="text" placeholder="Name" className="modal-input" />
          <input type="text" placeholder="Ticker" className="modal-input" />
          <textarea placeholder="Comment" className="modal-textarea"></textarea>

          <div className="modal-image-upload">
            <div className="upload-placeholder">
              <p>Drag and Drop Image</p>
              <span>(Optional)</span>
            </div>
          </div>

          <input
            type="text"
            placeholder="Twitter Link (Optional)"
            className="modal-input"
          />
          <input
            type="text"
            placeholder="Telegram Link (Optional)"
            className="modal-input"
          />
          <input
            type="text"
            placeholder="Website (Optional)"
            className="modal-input"
          />

          <button type="submit" className="modal-submit">
            Create a New Coin
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateCoin;
